<template>
  <div class="tagMonitoringSearch">
    <Row :gutter="4">
      <Col span="3">
        <Input v-model="ruleName" placeholder="规则名称"></Input>
      </Col>
      <Col span="3">
        <Select
          v-model="cloudType"
          filterable
          placeholder="云平台"
          :transfer="true"
          @on-change="changeCloudTypeOrCompany()"
        >
          <Option
            :value="item.id"
            v-for="item in cloudTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <div v-if="this.company == 1">
        <Col span="3">
          <Select
            v-model="companyId"
            filterable
            placeholder="公司"
            :transfer="true"
            @on-change="changeCloudTypeOrCompany()"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="3">
        <Select
          v-model="accountId"
          filterable
          placeholder="账号"
          :transfer="true"
          @on-change="getRegionList()"
        >
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <Col span="3">
        <Select v-model="region" filterable placeholder="区域" :transfer="true">
          <Option :value="item.id" v-for="item in regionList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <Col span="3">
        <Select
          v-model="resourceType"
          filterable
          placeholder="资源类型"
          :transfer="true"
        >
          <Option
            :value="item.id"
            v-for="item in resourceTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="2">
        <Button
          type="primary"
          v-hasPermission="['labelManagement:tagMonitoring:page']"
          @click="search"
          >查询</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableTagMonitoring from "./TableTagMonitoring";
import AddOrUpdateTagMonitoring from "./AddOrUpdateTagMonitoring";
import { getCookie } from "../../../../utils/cookieUtil";

var tableTagMonitoring = TableTagMonitoring;
export default {
  name: "TagMonitoringSearch",
  components: {
    AddOrUpdateTagMonitoring,
    TableTagMonitoring
  },
  data() {
    return {
      company: getCookie(global.companyId),
      addOrUpdateHandle: false,
      ruleName: "",
      cloudType: "",
      companyId: "",
      accountId: "",
      region: "",
      resourceType: "",
      cloudTypeList: [],
      companyList: [],
      accountList: [],
      regionList: [],
      resourceTypeList: []
    };
  },
  mounted() {
    // 查询云平台
    this.getAccountType();
    // 查询公司
    this.getCompanyList();
  },
  methods: {
    //查询云平台
    getAccountType: function() {
      this.$api.account
        .queryCloudPlatformsByCurrentUser(
          "userName",
          getCookie(global.cookieName)
        )
        .then(res => {
          this.cloudTypeList = res.data;
        });
    },
    // 公司
    getCompanyList: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyList = res.data.companies;
      });
    },
    // 切换云平台/公司
    changeCloudTypeOrCompany() {
      // 查询账号
      this.getAccountList();
      // 查询资源类型
      this.getResourceTypeList();
    },
    // 查询账户
    getAccountList: function() {
      this.accountId = "";
      this.accountList = [];
      if (
        this.StringUtils.isNotEmpty(this.cloudType) &&
        this.StringUtils.isNotEmpty(this.companyId)
      ) {
        let companyId = this.company == 1 ? this.companyId : this.company;
        this.$api.account
          .inquireAccount({
            type: this.cloudType,
            companyId: companyId
          })
          .then(res => {
            this.accountList = res.data;
          });
      }
    },
    // 查询区域
    getRegionList() {
      this.region = "";
      this.regionList = [];
      if (this.StringUtils.isNotEmpty(this.accountId)) {
        this.$api.account
          .queryAccountRegions("accountId", this.accountId)
          .then(res => {
            this.regionList = res.data;
          });
      }
    },
    // 查询资源类型
    getResourceTypeList() {
      if (this.StringUtils.isNotEmpty(this.cloudType)) {
        this.$api.resourceTagWarning
          .inquireResourceType("cloudType", this.cloudType)
          .then(res => {
            this.resourceTypeList = res.data;
          });
      }
    },
    // 查询
    search() {
      let params = {
        ruleName: this.ruleName,
        cloudType: this.cloudType,
        companyId: this.companyId,
        accountId: this.accountId,
        region: this.region,
        resourceType: this.resourceType
      };
      tableTagMonitoring.methods.showAll(params);
    }
  }
};
</script>
<style scoped>
.tagMonitoringSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_monitoring/TagMonitoringSearch.vue